import { REDO_COVERAGE_BUILDER_STORAGE_KEY } from "@redotech/redo-storefront-web/cache/keys";
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import {
  getSessionStorageWithExpiry,
  setSessionStorageWithExpiry,
} from "@redotech/redo-web/utils/session-storage-wrapper";

// some iframes will throw an error when accessing window.top
export function inIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function inCoverageBuilderMode() {
  const inCoverageBuilderMode = getSessionStorageWithExpiry(
    REDO_COVERAGE_BUILDER_STORAGE_KEY,
  );
  const queryParameters = new URLSearchParams(location.search);
  const hasCoverageBuilderQueryParam = queryParameters.get("coverage-builder");

  if (
    (!hasCoverageBuilderQueryParam && !inCoverageBuilderMode) ||
    !inIframe()
  ) {
    return false;
  }

  if (!inCoverageBuilderMode) {
    setSessionStorageWithExpiry(REDO_COVERAGE_BUILDER_STORAGE_KEY, true, 5);
  }

  return true;
}

export function autocheckPlacementSettingsDiffer(
  autocheck: WidgetAutocheck,
  previousAutocheck: WidgetAutocheck,
): boolean {
  if (
    autocheck.selector !== previousAutocheck.selector ||
    autocheck.attachmentStrategy !== previousAutocheck.attachmentStrategy ||
    autocheck.openShadowRoot !== previousAutocheck.openShadowRoot ||
    autocheck.checkoutSelector !== previousAutocheck.checkoutSelector ||
    autocheck.submitButtonSelector !== previousAutocheck.submitButtonSelector
  ) {
    return true;
  }

  const ct = autocheck.cartToggle;
  const pct = previousAutocheck.cartToggle;
  if (
    ct.cartToggleSelector !== pct.cartToggleSelector ||
    ct.cartShadowRootSelector !== pct.cartShadowRootSelector ||
    ct.cartToggleShadowRootSelector !== pct.cartToggleShadowRootSelector ||
    ct.cartClickListenerSelector !== pct.cartClickListenerSelector ||
    ct.cartTogglePlacement !== pct.cartTogglePlacement ||
    ct.useShadowRootInCart !== pct.useShadowRootInCart
  ) {
    return true;
  }

  if (autocheck.attachmentStrategy !== previousAutocheck.attachmentStrategy) {
    return true;
  }

  const wc = autocheck.widgetConfigs ?? [];
  const pwc = previousAutocheck.widgetConfigs ?? [];
  if (wc.length !== pwc.length) {
    return true;
  }
  for (const [i, element] of wc.entries()) {
    const w = element!;
    const pw = pwc[i]!;
    if (
      w.placementSelector !== pw.placementSelector ||
      w.insertionPosition !== pw.insertionPosition ||
      w.shadowRootSelector !== pw.shadowRootSelector ||
      w.placeInsideAndOutsideShadowRoot !==
        pw.placeInsideAndOutsideShadowRoot ||
      w.placementType !== pw.placementType
    ) {
      return true;
    }

    const pl = w.placement?.list ?? [];
    const ppl = pw.placement?.list ?? [];
    if (pl.length !== ppl.length) {
      return true;
    }
    for (const [j, element] of pl.entries()) {
      const d = element!;
      const pd = ppl[j]!;
      if (
        d.cssSelector !== pd.cssSelector ||
        d.insertionPosition !== pd.insertionPosition ||
        d.shadowRootSelector !== pd.shadowRootSelector ||
        d.hidingElementSelector !== pd.hidingElementSelector
      ) {
        return true;
      }
    }
  }

  return false;
}
